import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback, InputGroup, InputGroupAddon} from 'reactstrap';
import { metadataService } from '../../_services/metadata.service'
//import { connect } from "react-redux";
//import { Alert } from 'reactstrap';
//import validator from 'validator';


export class SlMoneyInput extends Component {
    constructor(props) {
        super(props);
        this.state = { visited: false,focused : false }
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
    }

    handleOnBlur(){
        this.setState({ visited : true, focused : false })
    }
    handleOnFocus(){
        this.setState({ focused : true })
    }

    render() {
        const label = this.props.labelName ? this.props.labelName : this.props.name; 
        const {focused} = this.state;
        const fieldName = this.props.label ? this.props.label : metadataService.getFieldNameLabel(label);
        let errorMessage = null; 
        let hasError = false; 
        if (this.props.fieldErrors && this.props.fieldErrors.length > 0){
            let fieldError = this.props.fieldErrors.find(e => e.fieldName === this.props.name); 
            if(fieldError){
                hasError = true; 
                errorMessage = metadataService.getMessage(fieldError.messageName, fieldName, ...(fieldError.args || []))
            }
        }
        else if(this.state.visited && this.props.isRequired && (this.props.value===null || this.props.value===undefined || this.props.value==="" ))
        {
            hasError = true; 
            errorMessage = metadataService.getMessage('RequiredFieldNotSupplied', fieldName)
        }
        else if(!metadataService.isNullOrEmpty(this.props.value) 
            && !metadataService.isNullOrEmpty(this.props.minAmount)
            && !metadataService.isNullOrEmpty(this.props.maxAmount))
        {
            const {value, minAmount, maxAmount,name} = this.props;
            if(Number(value) <= Number(minAmount)){
                hasError = true; 
                errorMessage = metadataService.getMessage('RequestedAmountMin',fieldName, minAmount)
            }else if (Number(value) > Number(maxAmount)){
                hasError = true; 
                errorMessage = metadataService.getMessage('RequestedAmountMax',fieldName, maxAmount)
            }
        }
        return (
            <FormGroup>
               
                <Label for={this.props.name} style={{ display: this.props.showLabel ? 'inline block' : 'none' }} className={this.props.isRequired && !this.props.disabled ? "required text-input-label" : "text-input-label"}>
                    {fieldName}</Label>
                   { this.props.showLabel === true && <br/>}
                 
                <InputGroup>
                    <InputGroupAddon className={(focused === true ? "focused " : "") + (hasError === true? "is-invalid" : "")} addonType="prepend">$</InputGroupAddon>
                    <Input type='number'
                        style={{borderLeft:0}}
                        className="sl-money-input"
                        invalid={hasError}
                        min={0}
                        max={this.props.maxValue}
                        step={this.props.step}
                        id={this.props.name + '_id'}
                        name={this.props.name}
                        value={this.props.value !== null || this.props.value !== undefined ? this.props.value : ''}
                        disabled={this.props.disabled}
                        onBlur={this.handleOnBlur}
                        onFocus={this.handleOnFocus}
                        onChange={this.props.onChange}
                        onInput={(e) => {
                            if (this.props.enforceMaxLength && this.props.maxLength) {
                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, this.props.maxLength); //note - does not allow decimal places
                            }
                            if (this.props.max && e.target.value > this.props.max) {
                                e.target.value = this.props.max;
                            }
                        }}
                        placeholder="" />
                    {hasError &&(<FormFeedback>{errorMessage}</FormFeedback> )}
                </InputGroup>
            </FormGroup>
        );
    }
}

//Define prop types
    SlMoneyInput.propTypes = {
        name: PropTypes.string.isRequired,
        labelName: PropTypes.string, 
        step: PropTypes.number,
        maxValue: PropTypes.number,
        maxLength: PropTypes.number,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.number, 
        fieldErrors: PropTypes.array, 
        helpText:PropTypes.string, 
        showLabel:PropTypes.bool, 
        isRequired: PropTypes.bool,
        disabled: PropTypes.bool,
        enforceMaxLength: PropTypes.bool,
        minAmount: PropTypes.number,
        maxAmount: PropTypes.number,
    }
    SlMoneyInput.defaultProps = {
        step: 10, 
        showLabel: true , 
        isRequired: true,
        disabled: false,
        maxLength: 6,
        enforceMaxLength: true,
        minAmount: null,
        maxAmount: null,
    }
